document.addEventListener("alpine:init", () => {
  Alpine.store("sync", {
    isSyncing: false,
  });
  Alpine.store("cartDrawer", {
    showDrawer: false,
    itemsCount: document.getElementById("cart_drawer").dataset.itemsCount,
    totalPrice: document.getElementById("cart_drawer").dataset.totalPrice,
    init() {
      this.openCart();
      this.initUpsellSlider();

      this.fixCurrencyMismatch();
    },
    async fixCurrencyMismatch() {
      // Check what currency the user is seeing (e.g. GBP)
      const activeCurrency = window.Shopify.currency.active;

      // Check what currency the cart backend thinks it is
      const cart = await this.getCart();

      // If they don't match (e.g. Cart is USD, User is GBP)
      if (activeCurrency && cart.currency !== activeCurrency) {
        console.log("Currency mismatch detected. Refreshing cart drawer...");

        // Force backend update
        await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ currency: activeCurrency }),
        });

        // Re-fetch HTML immediately so symbols update
        this.updateCartContent();
        this.updateCartCount();
      }
    },
    async updateCartCount() {
      const cartIconBubble = document.querySelector("#cart-icon-bubble");
      let cartCount = cartIconBubble.querySelector(".cart-count-bubble");

      const data = await this.getCart();
      console.log(data);
      const { item_count, total_price, items, total_discount } = data;
      this.itemsCount = item_count;
      this.totalPrice = total_price;

      if (cartCount) {
        // Update existing bubble
        cartCount.innerHTML = this.itemsCount;
      } else {
        // Create new bubble
        cartCount = document.createElement("div");
        cartCount.classList.add("cart-count-bubble");
        cartCount.innerHTML = this.itemsCount;
        cartIconBubble.appendChild(cartCount);
      }

      this.freeGift(items, item_count, total_discount);
    },
    freeGift(items, item_count, total_discount) {
      console.log("free gift logic running");

      let freeGiftId = null;
      let freeGiftQty = 0;
      let freeGiftKey = null;

      items.forEach((item) => {
        if (item.properties && "_free_gift" in item.properties) {
          freeGiftId = item.id; // assign id
          freeGiftQty = item.quantity;
          freeGiftKey = item.key;
        }
      });

      if (item_count > 2 && total_discount > 0 && freeGiftQty > 1) {
        let updates = {
          [freeGiftKey]: 1,
        };

        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        })
          .then((response) => {
            return response.json();
          })
          .then(() => {
            Alpine.store("cartDrawer").updateCartCount();
            Alpine.store("cartDrawer").updateCartContent();
          })

          .catch((error) => {
            console.error("Error:", error);
          });
      }
      if (total_discount == 0 && freeGiftQty > 0) {
        let updates = {
          [freeGiftKey]: 0,
        };

        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        })
          .then((response) => {
            return response.json();
          })
          .then(() => {
            Alpine.store("cartDrawer").updateCartCount();
            Alpine.store("cartDrawer").updateCartContent();
          })

          .catch((error) => {
            console.error("Error:", error);
          });
      }
      if (total_discount > 0 && freeGiftQty == 0) {
        const cartDrawer = document.querySelector("#cart_drawer");

        if (cartDrawer) {
          const freeGiftId = cartDrawer.dataset.freeGiftId;
          console.log("Free Gift ID:", freeGiftId);

          const formData = {
            items: [
              {
                id: Number(freeGiftId),
                quantity: 1,
                properties: {
                  _free_gift: "Yes",
                },
              },
            ],
          };

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              return response.json();
            })
            .then(() => {
              Alpine.store("cartDrawer").updateCartContent();
              Alpine.store("cartDrawer").updateCartCount();
            })

            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    },
    openCart() {
      const cartIcon = document.getElementById("cart-icon-bubble");
      cartIcon.removeAttribute("href");

      if (cartIcon) {
        cartIcon.addEventListener("click", (e) => {
          e.preventDefault();
          this.showDrawer = true;
          // You can add your custom logic here, like opening the cart modal
        });
      }
    },
    async getCart() {
      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const cart = await response.json();
        return cart; // contains items, total_price, etc.
      } catch (error) {
        console.error("Error fetching cart:", error);
      }
    },
    async updateCartContent() {
      fetch(window.Shopify.routes.root + `?section_id=cart-drawer-custom`)
        .then((response) => response.text())
        .then((sectionContent) => {
          // console.log(sectionContent);
          const newContent = new DOMParser()
            .parseFromString(sectionContent, "text/html")
            .querySelector("#cart_drawer");
          document.getElementById("cart_drawer").innerHTML =
            newContent.innerHTML;
        });

      setTimeout(() => {
        this.initUpsellSlider();
      }, 500);
    },
    initUpsellSlider() {
      const slider = document.getElementById("upsellSlider");
      this.sliderElement = new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 8,
        loop: false,
        speed: 1000,
        navigation: {
          nextEl: document.querySelector(".swiper-upsell-btn-next"),
          prevEl: document.querySelector(".swiper-upsell-btn-prev"),
        },
      });
    },
    estimateShipping() {
      const estimatedShipping = document.querySelector(".estimated-shipping");
      if (estimatedShipping) {
        const months = estimatedShipping
          .getAttribute("data-month-labels")
          .split(",");
        const days = rearrangeDays(
          estimatedShipping.getAttribute("data-day-labels").split(","),
        );

        const originalText = estimatedShipping.getAttribute("data-text");
        const shippingMinDays = parseInt(
          estimatedShipping.getAttribute("data-min-days"),
        );
        const shippingMaxDays = parseInt(
          estimatedShipping.getAttribute("data-max-days"),
        );
        const dateFormat = estimatedShipping.getAttribute("data-date-format");
        const textContainer = estimatedShipping.querySelector(
          ".estimated-shipping__text",
        );

        const currentDate = new Date();

        const startDate = addDays(currentDate, shippingMinDays);
        var startDateDaySuffix = "th";
        const startDay = startDate.getDate();
        if (startDay === 1 || startDay === 21 || startDay === 31)
          startDateDaySuffix = "st";
        else if (startDay === 2 || startDay === 22) startDateDaySuffix = "nd";
        else if (startDay === 3 || startDay === 23) startDateDaySuffix = "rd";

        const endDate = addDays(currentDate, shippingMaxDays);
        var endDateDaySuffix = "th";
        const endDay = endDate.getDate();
        if (endDay === 1 || endDay === 21 || endDay === 31)
          endDateDaySuffix = "st";
        else if (endDay === 2 || endDay === 22) endDateDaySuffix = "nd";
        else if (endDay === 3 || endDay === 23) endDateDaySuffix = "rd";

        let startDateString, endDateString;
        if (dateFormat === "day_dd_mm") {
          startDateString =
            days[startDate.getDay()] +
            ", " +
            startDate.getDate() +
            ". " +
            months[startDate.getMonth()];
          endDateString =
            days[endDate.getDay()] +
            ", " +
            endDate.getDate() +
            ". " +
            months[endDate.getMonth()];
        } else if (dateFormat === "mm_dd") {
          startDateString =
            months[startDate.getMonth()] +
            " " +
            startDate.getDate() +
            startDateDaySuffix;
          endDateString =
            months[endDate.getMonth()] +
            " " +
            endDate.getDate() +
            endDateDaySuffix;
        } else if (dateFormat === "dd_mm") {
          startDateString =
            startDate.getDate() + ". " + months[startDate.getMonth()];
          endDateString = endDate.getDate() + ". " + months[endDate.getMonth()];
        } else if (dateFormat === "day_dd_mm_numeric") {
          const startDateDay =
            String(startDate.getDate()).length > 1
              ? startDate.getDate()
              : "0" + startDate.getDate();
          const startDateMonth =
            String(startDate.getMonth() + 1).length > 1
              ? startDate.getMonth() + 1
              : "0" + (startDate.getMonth() + 1);
          startDateString =
            days[startDate.getDay()] +
            ", " +
            startDateDay +
            ". " +
            startDateMonth +
            ".";

          const endDateDay =
            String(endDate.getDate()).length > 1
              ? endDate.getDate()
              : "0" + endDate.getDate();
          const endDateMonth =
            String(endDate.getMonth() + 1).length > 1
              ? endDate.getMonth() + 1
              : "0" + (endDate.getMonth() + 1);
          endDateString =
            days[endDate.getDay()] +
            ", " +
            endDateDay +
            ". " +
            endDateMonth +
            ".";
        } else if (dateFormat === "dd_mm_numeric") {
          const startDateDay =
            String(startDate.getDate()).length > 1
              ? startDate.getDate()
              : "0" + startDate.getDate();
          const startDateMonth =
            String(startDate.getMonth() + 1).length > 1
              ? startDate.getMonth() + 1
              : "0" + (startDate.getMonth() + 1);
          startDateString = startDateDay + "/" + startDateMonth + "";

          const endDateDay =
            String(endDate.getDate()).length > 1
              ? endDate.getDate()
              : "0" + endDate.getDate();
          const endDateMonth =
            String(endDate.getMonth() + 1).length > 1
              ? endDate.getMonth() + 1
              : "0" + (endDate.getMonth() + 1);
          endDateString = endDateDay + "/" + endDateMonth + "";
        } else {
          // day_mm_dd
          startDateString =
            days[startDate.getDay()] +
            ", " +
            months[startDate.getMonth()] +
            " " +
            startDate.getDate() +
            startDateDaySuffix;
          endDateString =
            days[endDate.getDay()] +
            ", " +
            months[endDate.getMonth()] +
            " " +
            endDate.getDate() +
            endDateDaySuffix;
        }

        const textWithStartDate = originalText.replace(
          "[start_date]",
          startDateString,
        );
        const finalText = textWithStartDate.replace(
          "[end_date]",
          endDateString,
        );
        textContainer.innerHTML = finalText;
      }

      function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }

      function rearrangeDays(arr) {
        arr.unshift(arr[6]);
        arr.length = 7;
        return arr;
      }
    },
  });
  Alpine.store("convert", {
    formatShopifyMoney() {
      Shopify.money_format = "${{amount}}";
      Shopify.customFormatMoney = (cents, format) => {
        if (typeof cents == "string") {
          cents = cents.replace(".", "");
        }
        let value = "";
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let formatString = format || Shopify.money_format;

        const defaultOption = (opt, def) => {
          return typeof opt == "undefined" ? def : opt;
        };

        const formatWithDelimiters = (
          number,
          precision,
          thousands,
          decimal,
        ) => {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ",");
          decimal = defaultOption(decimal, ".");

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          let parts = number.split("."),
            dollars = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands,
            ),
            cents = parts[1] ? decimal + parts[1] : "";

          return dollars + cents;
        };

        // const isWholeNumber = cents % 100 === 0;

        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        }

        return `${formatString.replace(placeholderRegex, value)}`;
      };
    },

    convertPrice(price) {
      this.formatShopifyMoney();
      return Shopify.customFormatMoney(price, "{{ amount }}");
    },
  });

  (Alpine.data("cartProductCard", (element) => ({
    currentVariant: Number(element.dataset.variantId),
    currentVariantTitle: element.dataset.variantTitle,
    key: element.dataset.key,
    price: Number(element.dataset.price),
    compareAtPrice: Number(element.dataset.compareAtPrice),
    productQuantity: Number(element.dataset.quantity),
    propertyId: Number(element.dataset.propertyId),
    sellingPlanId: element.dataset.sellingPlanId
      ? Number(element.dataset.sellingPlanId)
      : null,
    loading: false,

    async removeItem() {
      this.loading = true;

      let updates = {
        [this.key]: 0,
      };

      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      })
        .then((response) => {
          return response.json();
        })
        .then(() => {
          Alpine.store("cartDrawer").updateCartCount();
          Alpine.store("cartDrawer").updateCartContent();
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
  })),
    Alpine.data("productQty", (isCart) => ({
      async updateCart() {
        this.loading = true;
        console.log(this.key);
        let data = {
          id: this.key,
          quantity: this.productQuantity,
          selling_plan: this.sellingPlanId,
          properties: {
            _id: this.propertyId,
          },
        };

        fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            return response.json();
          })
          .then(() => {
            Alpine.store("cartDrawer").updateCartCount();
            Alpine.store("cartDrawer").updateCartContent();
            this.loading = false;
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      },

      increaseProductQty() {
        console.log("quantity +");
        this.productQuantity++;
        isCart && this.updateCart();
        if (isCart == false) {
          this.totalPrice = this.currentVariantPrice * this.productQuantity;
        }
      },
      decreaseProductQty() {
        console.log("quantity -");
        this.productQuantity > 1
          ? this.productQuantity--
          : this.productQuantity;
        isCart && this.updateCart();
        if (isCart == false) {
          this.totalPrice = this.currentVariantPrice * this.productQuantity;
        }
      },
    })),
    Alpine.data("productOptionsFromCart", (el, handle) => ({
      async findMatchingVariantFromCart() {
        console.log(el);
        console.log(handle);

        this.loading = true;
        const response = await fetch(
          window.Shopify.routes.root + `products/${handle}.js`,
        );
        const product = await response.json();

        var selectedOption = [];
        el.querySelectorAll('input[type="radio"]:checked').forEach((radio) => {
          selectedOption.push(radio.value);
        });
        var matchedVariant = product.variants.find((variant) => {
          var pass = true;
          for (var i = 0; i < selectedOption.length; i++) {
            if (selectedOption.indexOf(variant.options[i]) === -1) {
              pass = false;
              break;
            }
          }
          return pass;
        });
        console.log(matchedVariant);

        try {
          // 5️⃣ Add new variant to cart
          const formData = {
            items: [
              {
                id: matchedVariant.id,
                quantity: this.productQuantity,
                properties: {
                  _id: this.propertyId,
                },
              },
            ],
          };

          const addResponse = await fetch(
            window.Shopify.routes.root + "cart/add.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            },
          );

          await addResponse.json(); // wait for response

          // 4️⃣ Update cart (remove old variant)
          const updates = {
            [this.key]: 0,
          };

          const updateResponse = await fetch(
            window.Shopify.routes.root + "cart/update.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates }),
            },
          );

          await updateResponse.json(); // wait for response

          // Update Alpine cart store again
          Alpine.store("cartDrawer").updateCartCount();
          Alpine.store("cartDrawer").updateCartContent();
          this.loading = false;
        } catch (error) {
          console.error("Error updating/adding cart:", error);
        }
      },
    })));

  Alpine.data("atcBtn", () => ({
    loading: false,
    init() {},
    addToCart() {
      this.loading = true;
      if (window.ShopifyUpsell) {
        window.ShopifyUpsell.open();
      }
      console.log(this.selectedQuantity);
      let formData = {};
      if (this.selectedQuantity === 1) {
        formData = {
          items: [
            {
              id: this.currentVariantId,
              quantity: 1,
              properties: {
                _id: Date.now(),
              },
            },
          ],
        };
      }

      if (this.selectedQuantity === 3) {
        formData = {
          items: [
            {
              id: this.productOne.id,
              quantity: 1,
              properties: {
                _id: "1",
              },
            },
            {
              id: this.productTwo.id,
              quantity: 1,
              properties: {
                _id: "2",
              },
            },
            {
              id: this.productThree.id,
              quantity: 1,
              properties: {
                _id: "3",
              },
            },
            {
              id: this.freeGiftId,
              quantity: 1,
              properties: {
                _free_gift: "Yes",
              },
            },
          ],
        };
      }

      console.log(formData);
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then(() => {
          Alpine.store("cartDrawer").updateCartCount();
          Alpine.store("cartDrawer").updateCartContent();
        })
        .then(() => {
          setTimeout(() => {
            this.loading = false;
            Alpine.store("cartDrawer").showDrawer = !window.ShopifyUpsell;
          }, 700);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    addToCartSubscriptions() {
      this.loading = true;

      formData = {
        items: [
          {
            id: this.currentVariantId,
            quantity: this.productQuantity,
            selling_plan: this.subscriptionId,
          },
        ],
      };
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then(() => {
          Alpine.store("cartDrawer").updateCartCount();
          Alpine.store("cartDrawer").updateCartContent();
        })
        .then(() => {
          setTimeout(() => {
            this.loading = false;
            Alpine.store("cartDrawer").showDrawer = !window.ShopifyUpsell;
          }, 700);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    addToCartBundle() {
      this.loading = true;

      let formData = {};
      const q = this.selectedQuantity;

      // Single
      if (q === 1) {
        formData = {
          items: [
            {
              id: this.currentVariantId,
              quantity: 1,
              properties: { _id: Date.now() },
            },
          ],
        };
      }

      // Bundles (3 / 6 / 8 total items added)
      if ([3, 6, 8].includes(q)) {
        const items = [];
        for (let i = 1; i <= q; i++) {
          const key = [
            "productOne",
            "productTwo",
            "productThree",
            "productFour",
            "productFive",
            "productSix",
            "productSeven",
            "productEight",
          ][i - 1];

          const pid = this[key]?.id;
          if (!pid) continue; // skip unset slots defensively

          items.push({
            id: pid,
            quantity: 1,
            properties: { _id: String(i) },
          });
        }

        formData = { items };
      }

      // Note: we do NOT add free gift here; your cartDrawer.freeGift() handles that.

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      })
        .then((r) => r.json())
        .then(() => {
          Alpine.store("cartDrawer").updateCartCount();
          Alpine.store("cartDrawer").updateCartContent();
        })
        .then(() => {
          setTimeout(() => {
            this.loading = false;
            Alpine.store("cartDrawer").showDrawer = !window.ShopifyUpsell;
          }, 700);
        })
        .catch((error) => {
          console.error("Error:", error);
          this.loading = false;
        });
    },

    upsellAddToCart(el, id, qty) {
      console.log("upsell id", id);
      this.loading = true;

      let formData = {};
      if (qty == 1) {
        formData = {
          items: [
            {
              id: id,
              quantity: qty,
            },
          ],
        };
      }
      if (qty == 2) {
        formData = {
          items: [
            {
              id: id,
              quantity: 1,
              properties: {
                _id: Date.now(),
              },
            },
            {
              id: id,
              quantity: 1,
              properties: {
                _id: Date.now() + 1,
              },
            },
          ],
        };
      }

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then(() => {
          Alpine.store("cartDrawer").updateCartCount();
          Alpine.store("cartDrawer").updateCartContent();
          this.loading = false;
        })

        .catch((error) => {
          console.error("Error:", error);
        });
    },
  }));
});
